import { BaseNumber, promiseAll } from '@sparkdotfi/common-universal'
import { QueryKey } from '@tanstack/react-query'
import { Config } from 'wagmi'
import { readContract } from 'wagmi/actions'

import { stusdsAbi, stusdsAddress } from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'

export function stusdsDepositDataQueryKey({ chainId }: { chainId: number }): QueryKey {
  return ['stusds-deposit-validator', chainId]
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export async function stusdsDepositDataQueryFunction({
  wagmiConfig,
  chainId,
}: {
  wagmiConfig: Config
  chainId: number
}) {
  const { totalSupply, cap } = await promiseAll(
    {
      totalSupply: () =>
        readContract(wagmiConfig, {
          address: getContractAddress(stusdsAddress, chainId),
          abi: stusdsAbi,
          functionName: 'totalSupply',
        }),
      cap: () =>
        readContract(wagmiConfig, {
          address: getContractAddress(stusdsAddress, chainId),
          abi: stusdsAbi,
          functionName: 'cap',
        }),
    },
    { concurrency: 'unbounded' },
  )

  return {
    totalSupply: BaseNumber(totalSupply).toNormalizedUnit(18),
    cap: BaseNumber(cap).toNormalizedUnit(18),
  }
}
